import React from "react";
import {connect} from "react-redux";
import { Switch, Route } from "react-router-dom";


import Form from 'views/IbTree/Form'
import List from 'views/IbTree/List'
import IbtreeWizard from 'views/IbTree/Wizard'


class IbTree extends React.Component {
  render() {
    const {match}=this.props;
    return (

          <Switch>
            <Route exact path={`${match.path}/add`} component={Form}/>
            <Route exact path={`${match.path}/:id`} component={Form}/>
            <Route exact path={`${match.path}/wizard/:profileId/:id/`} component={IbtreeWizard}/>
            <Route component={List}/>
          </Switch>

    );
  }
}
const state=(state)=>({})
const dispatch=(dispatch)=>({})
export default connect(state,dispatch)(IbTree);



// WEBPACK FOOTER //
// ./src/views/IbTree/IbTree.jsx